import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, catchError, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class BorderouDatatableService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;
    private getBorderouListURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .list;

    private storeURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .store;
    private updateURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .update;
    private deleteURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .delete;
    private getActiveURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .listActive;
    private getPublicURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .listPublic;
    private changeActiveURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .changeActive;
    private changePublicURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable
            .changePublic;

    constructor(private http: HttpClient) { }

    addBorderou(payload: any) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    update(payload: any) {
        return this.http.put(this.updateURL, payload, this.httpOptions);
    }

    delete(id: number) {
        return this.http.delete(this.deleteURL + id);
    }

    getActive() {
        return this.http.get(this.getActiveURL, this.httpOptions);
    }

    getPublic() {
        return this.http.get(this.getPublicURL, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeActiveURL + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changePublicURL + id, {}, this.httpOptions);
    }

    getList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getBorderouListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get request priorities:", error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
